// extracted by mini-css-extract-plugin
export default {"base":"CardHeader_base__eMm68","icon":"CardHeader_icon__nPdGr"};